import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import 'url-search-params'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
// LightBootstrap plugin
import VueSweetalert2 from 'vue-sweetalert2'
const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}
Vue.use(VueSweetalert2, options)
import LightBootstrap from './light-bootstrap-main'
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, { load: { key: 'AIzaSyDmky5VANrOWXcBoXmP3JpusSZIx5-k8M8' } })
import VueGeolocation from 'vue-browser-geolocation'
Vue.use(VueGeolocation)
// router setup
import routes from './routes/routes'
// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(Buefy)
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
Vue.use(VueToast)
import VueNumericInput from 'vue-numeric-input'
Vue.use(VueNumericInput)
// configure router
const router = new VueRouter({
  base: __dirname,
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})



// WEBPACK FOOTER //
// ./src/main.js